<template>
    <span
        class="employee-avatar"
        :style="sizeStyle"
        :title="showTitle ? name || null : null"
        aria-hidden="true"
    >
        <img
            v-if="visibleImageUrl"
            :src="visibleImageUrl"
            :alt="name || ''"
            @error="imageFailed = true"
        >
        <span v-else class="employee-avatar__fallback">
            {{ initials }}
        </span>
    </span>
</template>

<script>
export default {
    name: 'EmployeeAvatar',
    props: {
        showTitle: {type: Boolean, default: true},
        avatarUrl: {
            type: String,
            default: null
        },
        name: {
            type: String,
            default: ''
        },
        firstName: {
            type: String,
            default: ''
        },
        lastName: {
            type: String,
            default: ''
        },
        size: {
            type: [Number, String],
            default: 34
        }
    },
    data() {
        return {
            imageFailed: false
        };
    },
    computed: {
        visibleImageUrl() {
            return this.imageFailed ? null : this.avatarUrl;
        },
        initials() {
            const direct = [this.lastName, this.firstName]
                .map(value => String(value || '').trim())
                .filter(Boolean);
            const values = direct.length
                ? direct
                : String(this.name || '').trim().split(/\s+/).filter(Boolean).slice(0, 2);
            return values
                .map(value => value.charAt(0).toUpperCase())
                .join('')
                .slice(0, 2) || '?';
        },
        sizeStyle() {
            const size = Math.max(24, Number(this.size) || 34);
            return {
                width: `${size}px`,
                height: `${size}px`,
                flexBasis: `${size}px`,
                fontSize: `${Math.max(10, Math.round(size * 0.31))}px`
            };
        }
    },
    watch: {
        avatarUrl() {
            this.imageFailed = false;
        }
    }
};
</script>

<style scoped>
.employee-avatar {
    display: inline-flex;
    flex: 0 0 auto;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    border: 1px solid #c9d9e7;
    border-radius: 50%;
    background: #dfeefa;
    color: #2f6ea7;
    font-weight: 700;
    line-height: 1;
    vertical-align: middle;
}

.employee-avatar img,
.employee-avatar__fallback {
    width: 100%;
    height: 100%;
}

.employee-avatar img {
    display: block;
    object-fit: cover;
}

.employee-avatar__fallback {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
